<template>
    <Cell :class="type" :title="text">
        <Label v-if="title==''" :text="type" :type="type" slot="icon"/>
        <Label  v-else :text="title" :type="type" slot="icon"/>
        <span slot="extra">{{time}}</span>
    </Cell>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        },
        text:{
            type:String,
            default:'this is log text'
        },
        type:{
            type:String,
            default:''
        },
        time:{
            type:String,
            default:'2019-04-21 10:11:12'
        }
    }
}
</script>
